import roles from "@/roles";
export default [
  {
    icon: "alarm",
    title: "Time Tracking",
    roles: [roles.ADMIN, roles.TIME_ADMIN],
    children: [
      {
        router: true,
        title: "Hours Worked",
        to: "HoursWorked",
        roles: [roles.ADMIN, roles.TIME_ADMIN]
      }
    ]
  }
];
